import { combineReducers } from 'redux';
import { takeEvery, call } from 'redux-saga/effects';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';
import mapScores from '../utils/map-scores';

const FETCH_CANDIDATE_SCORE = 'candidate/FETCH_CANDIDATE_SCORE';
const GENERATE_PDF = 'candidate/GENERATE_PDF';

const candidateInfo = (state = null, action) => {
    switch (action.type) {
        case actionKey.success(FETCH_CANDIDATE_SCORE):
            return {
                ...action.payload,
                scores: mapScores(action.payload.scores),
            };
        default:
            return state;
    }
};

const loadingReducer = (state = false, action) => {
    switch (action.type) {
        case actionKey.init(FETCH_CANDIDATE_SCORE):
            return true;
        case actionKey.failure(FETCH_CANDIDATE_SCORE):
        case actionKey.success(FETCH_CANDIDATE_SCORE):
            return false;
        default:
            return state;
    }
};

const errorReducer = (state = null, action) => {
    switch (action.type) {
        case FETCH_CANDIDATE_SCORE:
        case actionKey.success(FETCH_CANDIDATE_SCORE):
            return null;
        case actionKey.failure(FETCH_CANDIDATE_SCORE):
            return action.error;
        default:
            return state;
    }
};

export default combineReducers({
    info: candidateInfo,
    loading: loadingReducer,
    error: errorReducer,
});

export const fetchCandidateScoreAction = userId => ({
    type: FETCH_CANDIDATE_SCORE,
    userId,
});


export const generatePdfAction = ({ userId, positionId, resolve, reject }) => ({
    type: GENERATE_PDF,
    userId,
    positionId,
    resolve,
    reject,
});


export function* rootSaga() {
    yield [
        takeEvery(FETCH_CANDIDATE_SCORE, fetchCandidateScore),
        takeEvery(GENERATE_PDF, generatePdf),
    ];
}

export function* generatePdf({ type, userId, positionId, resolve, reject }) {
    const result = yield call(request, {
        type,
        url: '/api/candidate/generate-pdf',
        options: {
            method: 'POST',
            body: {
                userId,
                positionId,
            },
        },
    });
    if (!result || result.error) {
        reject(result.error);
    } else {
        resolve(result.payload.file);
    }
}

function* fetchCandidateScore({ type, userId }) {
    yield call(request, {
        url: `/api/users/candidate/${userId}`,
        type,
        userId,
    });
}



// WEBPACK FOOTER //
// ./src/client/redux/candidate.js